import { inject } from '@angular/core';
import {
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { RouterQuery } from '@datorama/akita-ng-router-store';
import { Observable, map } from 'rxjs';

const parseUrlForOutlets = (url: string) => {
    const auxillaryRouteRegex = /\(([^)]+)\)/g;
    const auxillaryOutlets: { [key: string]: string } = {};

    // Parse auxiliary outlet paths from the URL
    let match;
    while ((match = auxillaryRouteRegex.exec(url)) !== null) {
        const [outlet, path] = match[1].split(':');
        auxillaryOutlets[outlet] = path;
    }
    return Object.keys(auxillaryOutlets).length > 0 ? auxillaryOutlets : null;
};

export const preserveQueryParamsGuard = (
    route: ActivatedRouteSnapshot,
    snapshotState: RouterStateSnapshot
): Observable<true | UrlTree> => {
    const routerQuery = inject(RouterQuery);
    const router = inject(Router);
    return routerQuery.select().pipe(
        map(({ state }) => {
            if (!state) {
                return true;
            }
            const { url, queryParams } = state;
            if (!(url || queryParams)) {
                return true;
            }
            const currentUrl = snapshotState.url;
            const outlets = parseUrlForOutlets(currentUrl);
            // Make it possible to use guard for any route (not just aux routes)
            if (!outlets && currentUrl !== url) {
                return router.createUrlTree([snapshotState.url], {
                    queryParams: queryParams
                });
            }

            // ... else check which query params are specified
            const urlTree = router.parseUrl(currentUrl);
            const currentParams = urlTree.queryParams;

            // ... but make sure we have changed parameters to allow rerouting
            const paramsMatch = Object.keys(queryParams).every(
                (key) => currentParams[key] === queryParams[key]
            );

            if (!paramsMatch && Object.keys(outlets).length > 0) {
                return router.createUrlTree([{ outlets: outlets }], {
                    queryParams: queryParams
                });
            }
            return true;
        })
    );
};
